import React from 'react';

interface Props {
  summaryItem: { title: string; count: number };
}

const SummaryCard: React.FC<Props> = ({ summaryItem }) => {
  return (
    <div className="summary-card-container">
      <span className="summary-card-title">{summaryItem.title}</span>
      <span className="summary-card-count">{summaryItem.count}</span>
    </div>
  );
};

export default SummaryCard;
